import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent, DesignBlockImageScope, DesignBlockTextAndMediaScope, Field, Scope, WebsitePageScope } from '@sb/library/base';
import { WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaImageDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';

export class TextDesignBlockScope extends Scope {
    websiteBlockData = Field<WebsiteBlockTextAndMediaDisplayItem>();
    imageData = Field<WebsiteBlockTextAndMediaImageDisplayItem>();
}

@Component({
    selector: 'lib-text-design-block',
    templateUrl: './text-design-block.component.html',
    styleUrls: ['./text-design-block.component.scss']
})
export class TextDesignBlockComponent extends DesignBlockBaseViewComponent implements TextDesignBlockScope, DesignBlockImageScope {

    override Scope = this.SetScope({
        Implements: [DesignBlockTextAndMediaScope, DesignBlockImageScope],
        Requires: WebsitePageScope
    });

    @Input() websiteBlockData!: WebsiteBlockTextAndMediaDisplayItem;

    IsMediaRightBlock(blockKind: WebsiteBlockTextAndMediaType): boolean {
        return  blockKind === WebsiteBlockTextAndMediaType.MediaRight ||
        blockKind === WebsiteBlockTextAndMediaType.MediaRightTwoColumn ||
        blockKind === WebsiteBlockTextAndMediaType.MediaRightShadow ||
        blockKind === WebsiteBlockTextAndMediaType.MediaRightClipped ||
        blockKind === WebsiteBlockTextAndMediaType.MediaRightTestimonial ||
        blockKind ===  WebsiteBlockTextAndMediaType.MediaRightAccentBackgroundTestimonial;
    }

    get hasHeader(): boolean {
        return this.websiteBlockData.Header !== null;
    }

    get hasBody(): boolean {
        return this.websiteBlockData.Body !== null;
    }

    get kind(): WebsiteBlockTextAndMediaType {
        return this.websiteBlockData.TextAndMediaType;
    }

    get imageData(): WebsiteBlockTextAndMediaImageDisplayItem {
        return this.websiteBlockData.Images[0];
    }
}
